"use strict";

var cov_1mwxka9g2v = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\license\\License.js";
  var hash = "fd56420ee0d0047aa8fbc3aa7c62db87455f9daf";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\license\\License.js",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 23
        },
        end: {
          line: 28,
          column: 1
        }
      },
      "1": {
        start: {
          line: 14,
          column: 18
        },
        end: {
          line: 14,
          column: 29
        }
      },
      "2": {
        start: {
          line: 15,
          column: 19
        },
        end: {
          line: 15,
          column: 73
        }
      },
      "3": {
        start: {
          line: 15,
          column: 41
        },
        end: {
          line: 15,
          column: 68
        }
      },
      "4": {
        start: {
          line: 16,
          column: 25
        },
        end: {
          line: 16,
          column: 79
        }
      },
      "5": {
        start: {
          line: 16,
          column: 34
        },
        end: {
          line: 16,
          column: 54
        }
      },
      "6": {
        start: {
          line: 16,
          column: 55
        },
        end: {
          line: 16,
          column: 77
        }
      },
      "7": {
        start: {
          line: 18,
          column: 19
        },
        end: {
          line: 21,
          column: 3
        }
      },
      "8": {
        start: {
          line: 23,
          column: 19
        },
        end: {
          line: 23,
          column: 95
        }
      },
      "9": {
        start: {
          line: 25,
          column: 2
        },
        end: {
          line: 27,
          column: 4
        }
      },
      "10": {
        start: {
          line: 30,
          column: 0
        },
        end: {
          line: 39,
          column: 2
        }
      },
      "11": {
        start: {
          line: 40,
          column: 18
        },
        end: {
          line: 44,
          column: 3
        }
      },
      "12": {
        start: {
          line: 40,
          column: 41
        },
        end: {
          line: 44,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 8,
            column: 23
          },
          end: {
            line: 8,
            column: 24
          }
        },
        loc: {
          start: {
            line: 12,
            column: 6
          },
          end: {
            line: 28,
            column: 1
          }
        },
        line: 12
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 15,
            column: 31
          },
          end: {
            line: 15,
            column: 32
          }
        },
        loc: {
          start: {
            line: 15,
            column: 41
          },
          end: {
            line: 15,
            column: 68
          }
        },
        line: 15
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 16,
            column: 25
          },
          end: {
            line: 16,
            column: 26
          }
        },
        loc: {
          start: {
            line: 16,
            column: 32
          },
          end: {
            line: 16,
            column: 79
          }
        },
        line: 16
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 40,
            column: 29
          },
          end: {
            line: 40,
            column: 30
          }
        },
        loc: {
          start: {
            line: 40,
            column: 41
          },
          end: {
            line: 44,
            column: 1
          }
        },
        line: 40
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "fd56420ee0d0047aa8fbc3aa7c62db87455f9daf"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.License = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _InfoOutlined = _interopRequireDefault(require("@material-ui/icons/InfoOutlined"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

cov_1mwxka9g2v.s[0]++;

var License = function License(_ref) {
  var rights = _ref.rights,
      licenseLink = _ref.licenseLink,
      iconProps = (0, _objectWithoutProperties2.default)(_ref, ["rights", "licenseLink"]);
  cov_1mwxka9g2v.f[0]++;
  var classes = (cov_1mwxka9g2v.s[1]++, useStyles());
  var openLink = (cov_1mwxka9g2v.s[2]++, (0, _react.useCallback)(function (link) {
    cov_1mwxka9g2v.f[1]++;
    cov_1mwxka9g2v.s[3]++;
    return window.open(link, '_blank');
  }, []));
  cov_1mwxka9g2v.s[4]++;

  var onClickLicense = function onClickLicense(e) {
    cov_1mwxka9g2v.f[2]++;
    cov_1mwxka9g2v.s[5]++;
    e.stopPropagation();
    cov_1mwxka9g2v.s[6]++;
    openLink(licenseLink);
  };

  var _iconProps = (cov_1mwxka9g2v.s[7]++, _objectSpread({
    onClick: onClickLicense
  }, iconProps));

  var rightsIcon = (cov_1mwxka9g2v.s[8]++, _react.default.createElement(_core.Tooltip, {
    title: rights,
    arrow: true
  }, _react.default.createElement(_InfoOutlined.default, _iconProps)));
  cov_1mwxka9g2v.s[9]++;
  return _react.default.createElement(_react.default.Fragment, null, rightsIcon);
};

exports.License = License;
cov_1mwxka9g2v.s[10]++;
License.propTypes = {
  /** @ignore */
  classes: _propTypes.default.object,

  /** rights string from manifest, such as "CC BY-SA 4.0" */
  rights: _propTypes.default.string.isRequired,

  /** number of iterations before timing out */
  licenseLink: _propTypes.default.string.isRequired,

  /** The overriding CSS for this component */
  style: _propTypes.default.object
};
var useStyles = (cov_1mwxka9g2v.s[11]++, (0, _styles.makeStyles)(function (theme) {
  cov_1mwxka9g2v.f[3]++;
  cov_1mwxka9g2v.s[12]++;
  return {
    root: {}
  };
}));
var _default = License;
exports.default = _default;